import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LegacyLocaleRedirectComponent } from './core/components/legacy-locale-redirect/legacy-locale-redirect.component';

const routes: Routes = [
  {
    path: 'en',
    children: [{ path: '**', component: LegacyLocaleRedirectComponent }],
  },
  {
    path: 'ar',
    children: [{ path: '**', component: LegacyLocaleRedirectComponent }],
  },
  { path: 'login', redirectTo: 'account/login', pathMatch: 'full' },
  { path: 'signin', redirectTo: 'account/login', pathMatch: 'full' },
  { path: 'register', redirectTo: 'account/register', pathMatch: 'full' },
  { path: 'my-account', redirectTo: 'account', pathMatch: 'full' },
  { path: 'userregister', redirectTo: 'account/register', pathMatch: 'full' },
  {
    path: '',
    loadChildren: () =>
      import('./features/page/page.module').then((m) => m.PageModule),
  },
  {
    path: 'page/:slug',
    loadChildren: () =>
      import('./features/page/page.module').then((m) => m.PageModule),
  },
  {
    path: 'category/:id',
    loadChildren: () =>
      import('./features/catalog/catalog.module').then((m) => m.CatalogModule),
  },
  {
    path: 'product/:slug',
    loadChildren: () =>
      import('./features/product/product.module').then((m) => m.ProductModule),
  },
  {
    // Legacy / Ads final URLs used plural "products" — keep them working.
    path: 'products/:slug',
    loadChildren: () =>
      import('./features/product/product.module').then((m) => m.ProductModule),
  },
  {
    path: 'cart',
    loadChildren: () =>
      import('./features/cart/cart.module').then((m) => m.CartModule),
  },
  {
    path: 'checkout',
    loadChildren: () =>
      import('./features/checkout/checkout.module').then((m) => m.CheckoutModule),
  },
  {
    path: 'account',
    loadChildren: () =>
      import('./features/account/account.module').then((m) => m.AccountModule),
  },
  {
    path: 'wishlist',
    loadChildren: () =>
      import('./features/wishlist/wishlist.module').then((m) => m.WishlistModule),
  },
  {
    path: 'compare',
    loadChildren: () =>
      import('./features/compare/compare.module').then((m) => m.CompareModule),
  },
  {
    path: 'support',
    loadChildren: () =>
      import('./features/support/support.module').then((m) => m.SupportModule),
  },
  {
    path: 'return-and-exchange-policy',
    loadChildren: () =>
      import('./features/return-policy/return-policy.module').then((m) => m.ReturnPolicyModule),
  },
  {
    path: 'branches',
    loadChildren: () =>
      import('./features/branches/branches.module').then((m) => m.BranchesModule),
  },
  {
    path: 'search',
    loadChildren: () =>
      import('./features/search/search.module').then((m) => m.SearchModule),
  },
  {
    path: '**',
    loadChildren: () =>
      import('./features/not-found/not-found.module').then(
        (m) => m.NotFoundModule
      ),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top', paramsInheritanceStrategy: 'always' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
